// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Form__wrapper___1yGXG","h2":"Form__h2___3j_tQ","form":"Form__form___2N3f9","field":"Form__field___297hT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePassword/Form.scss
// module id = LHSi
// module chunks = 0